import {
  useMutation,
  useQueryClient,
  type UseMutationResult,
} from '@tanstack/react-query';
import type {
  BillingCancelSubscriptionRequest,
  BillingCancelSubscriptionResponse,
} from '@kawai/shared';
import { callBillingCancelSubscription } from '../api/billingCancelSubscription.js';

/**
 * TP-23: `billingCancelSubscription` Callable を呼ぶ React Query mutation hook。
 *
 * 成功時は `['tenants']` と `['billing_subscriptions']` を invalidate し、解約予約中バッジ /
 * 再開ボタン活性を即時反映する。
 */
export function useBillingCancelSubscription(): UseMutationResult<
  BillingCancelSubscriptionResponse,
  Error,
  BillingCancelSubscriptionRequest
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: BillingCancelSubscriptionRequest) =>
      callBillingCancelSubscription(input),
    onSuccess: async () => {
      // 互いに無関係な refetch を並列化（直列 await は不要 / レビュー指摘）。
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['tenants'] }),
        queryClient.invalidateQueries({ queryKey: ['billing_subscriptions'] }),
      ]);
    },
  });
}
